<template>
	<ul class="navi-group mb-3">
		<li class="navi-item nav-heading rounded">Kontakt</li>
		<li class="nav-item" @click="toggleMenu"><router-link :to="{name: 'kontakt-anfrage'}" class="nav-link" exact>Beratungsanfrage</router-link></li>
		<li class="p-3">
			<strong>mietmeile.de</strong> <br>
			<a href="tel:+49 (0) 40 244 249 300" style="color: black">+49 (0) 40 244 249 300</a> <br>
			<a href="mailto:info@mietmeile.de" style="color: black">info@mietmeile.de</a>
		</li>
	</ul>
</template>

<script>
	import { ToggleMenuMixin } from '../../../mixins/ToggleMenu';

    export default {
        mixins: [ToggleMenuMixin]
    }
</script>

<style scoped>

</style>
